/**
 * Vocabulario de `program.kind` — espejo EXACTO del CHECK de la migración
 * (`00055_academy_programs.sql`, ampliado por `00090_free_tier_and_funnel.sql`).
 *
 * Existía repetido en tres sitios (la mutación, la vista de programas y el
 * comentario del schema del cliente) y por eso añadir `workshop` obligaba a
 * tocar los tres sin que nada fallara si te olvidabas de uno. Aquí es una lista.
 *
 * `workshop` (B5 · gap analysis §N, acción `N2`): un taller de 1–2 sesiones
 * sueltas. No es `free_course` —que es un curso libre completo— ni una carrera
 * de tres meses: es el formato del GANCHO, y el catálogo necesita distinguirlo
 * para que el carril «Gratis» no mezcle un taller de tres horas con una carrera
 * regalada.
 */

export const PROGRAM_KINDS = ["career", "diploma", "workshop", "free_course"] as const;
export type ProgramKind = (typeof PROGRAM_KINDS)[number];

/** Kind por defecto de un programa nuevo (el menos comprometido). */
export const DEFAULT_PROGRAM_KIND: ProgramKind = "free_course";

/**
 * Normaliza lo que venga de un `<select>` o de la base al vocabulario.
 *
 * El estrechamiento se hace con un type guard y no con `as`: un `as` aquí
 * aceptaría en silencio cualquier `kind` que la base tuviera de más (o de
 * menos) tras una migración, que es justo el caso que esta función existe para
 * atrapar.
 */
function isProgramKind(value: string): value is ProgramKind {
  return (PROGRAM_KINDS as readonly string[]).includes(value);
}

export function asProgramKind(value: string | null | undefined): ProgramKind {
  return value != null && isProgramKind(value) ? value : DEFAULT_PROGRAM_KIND;
}

/**
 * ¿Este tipo de programa es un TALLER? Lo consumen el catálogo y la landing para
 * etiquetar el carril «Gratis».
 */
export function isWorkshop(kind: string | null | undefined): boolean {
  return kind === "workshop";
}
